import { useContext, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import GlobalContext from "./components/common/Context";
import { ErrorBoundary } from "react-error-boundary";
import LoadingModal from "./components/common/LoadingModal/LoadingModal";
import SignIn from "./components/pages/signin/SignIn";
import Docs from "./components/pages/docs/Docs";
import useMediaQuery from "@mui/material/useMediaQuery";
import getCustomMuiTheme from "./CustomMuiTheme";
import useFirebaseAuthentication from "./components/Firebase/hooks";

const customTheme = getCustomMuiTheme("light");

const App = () => {
  const { setView } = useContext(GlobalContext);
  const { isAuthenticated, isCheckingAuth } = useFirebaseAuthentication();

  const tabletView = useMediaQuery("(max-width:1280px) and (min-width:744px)");
  const mobileView = useMediaQuery("(max-width:743px) and (min-width:300px)");
  const largeView = useMediaQuery("(min-width:2000px)");

  useEffect(() => {
    setView(mobileView, tabletView, largeView);
  }, [mobileView, tabletView, largeView, setView]);

  const RequireAuth = ({ children, redirectTo }) => {
    return isCheckingAuth ? (
      <LoadingModal width={6} />
    ) : isAuthenticated ? (
      children
    ) : (
      <Navigate to={redirectTo} />
    );
  };

  const PublicRoute = ({ children, redirectTo }) => {
    return isCheckingAuth ? (
      <LoadingModal width={6} />
    ) : !isAuthenticated ? (
      children
    ) : (
      <Navigate to={redirectTo} />
    );
  };

  return (
    <div className="App">
      <Router>
        <ThemeProvider theme={customTheme}>
          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute redirectTo="/docs">
                  <ErrorBoundary fallback={<div>Something went wrong</div>}>
                    <SignIn />
                  </ErrorBoundary>
                </PublicRoute>
              }
            />
            <Route
              path="/docs"
              element={
                <RequireAuth redirectTo="/">
                  <ErrorBoundary fallback={<div>Something went wrong</div>}>
                    <Docs />
                  </ErrorBoundary>
                </RequireAuth>
              }
            />
          </Routes>
        </ThemeProvider>
      </Router>
    </div>
  );
};

export default App;
